import CoreApiService from "../../system/api/coreApiService";
import { DocumentDataProviderV2 } from "./Common/DocumentDataProviderV2";
import InvoiceCashOrderRequest from "../../libs/core-api-requests/documents/invoiceCashOrderRequest";
import { IInvoiceCashOrderCreateDTO, IInvoiceCashOrderEditDTO, IInvoiceCashOrderGetDTO, IInvoiceCashOrderViewDTO } from "../../libs/coreapi-dto/documents/invoiceCashOrder";
import { IBaseDocumentItemDTO } from "../../libs/coreapi-dto/documents/base";

export class InvoiceCashOrderDataProvider extends DocumentDataProviderV2<IInvoiceCashOrderViewDTO, IInvoiceCashOrderGetDTO, IInvoiceCashOrderCreateDTO, IInvoiceCashOrderEditDTO, IInvoiceCashOrderViewDTO, IBaseDocumentItemDTO> {
    private _coreApiService: CoreApiService;

    constructor(coreApiService: CoreApiService) {
        super();
        this._coreApiService = coreApiService
    }

    getDataRequest(): Promise<InvoiceCashOrderRequest> {
        return this._coreApiService.invoiceCashOrderRequest;
    }
}